import React from 'react';

import RgbSection from './components/RgbSection';
import Swatch from './components/Swatch';

export default function App() {
  return (
    <div>
      <RgbSection />
      <Swatch />
    </div>
  );
}
